import React, { Component } from "react";

export default class FlightRowLazyLoad extends Component {
	render() {
		return (
			<div className="flight-item">
				<div className="container-fluid">
					<div className="row">
						<div className="col-xs-16 col-md-12 flight-item-information">
							<div className="row">
								<div className="col-xs-16 col-md-4">
									<div className="lazyload" />
								</div>
								<div className="col-xs-16 col-md-4">
									<div className="lazyload" />
								</div>
								<div className="col-xs-16 col-md-4">
									<div className="lazyload" />
								</div>
								<div className="col-xs-16 col-md-4">
									<div className="lazyload no-margin-bottom" />
								</div>
							</div>
						</div>
						<div className="col-xs-16 col-md-4 flight-item-price hidden-xs hidden-sm">
							<div className="lazyload" />
						</div>
					</div>
				</div>
			</div>
		);
	}
}
